<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qM90aP/images/9780759522770.jpg?1732137048577" alt="This image is the cover for the book Sins of Summer, Wyoming Frontier"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sins of Summer, Wyoming Frontier
      </h1>
      <p class="bookDescription body article font2">
        <p>A sizzling novel of love and revenge on the wild frontier. In an Idaho logging camp, Dory bears a child by the handsome son of a rival mill owner--but the child's father dies before they can be married. Then rugged Benton rides into her life, a man who ignites both gunfire between the feuding families and passion in Dory's heart.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Garlock
      </h2>
      
      <p class="authorDescription body article"><B>Dorothy Garlock</B> is the author of more than 50 novels that have sold 15 million+ combined copies and are published in 15 languages. She lives in Iowa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      GRAND CENTRAL PUBLISHING
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f77915d8